import { Injectable } from '@angular/core';
@Injectable()
export class TimeHelper {
  constructor() {}

  getTimeStringByMiliseconds(time: number, needSpace: boolean) {
    const hour = Math.floor(time / (60 * 60 * 1000));
    const minutes = Math.floor((time - hour * (60 * 60 * 1000)) / 60000);
    const seconds = Math.floor(
      (time - hour * (60 * 60 * 1000) - minutes * 60000) / 1000
    );

    return (
      (hour < 10 ? '۰' + hour : hour) +
      (needSpace ? ' : ' : ':') +
      (minutes < 10 ? '۰' + minutes : minutes) +
      (needSpace ? ' : ' : ':') +
      (seconds < 10 ? '۰' + seconds : seconds)
    );
  }
}
